import { CONSTANTS } from '../constants'
import { User } from '../types'

// Until the Podcasts section launches, only preview users see its content;
// everyone else sees a Coming Soon message.
export const isPodcastPreviewUser = (user?: User) =>
  user?.email !== undefined &&
  CONSTANTS.PODCASTS.PREVIEW_USERS.includes(user.email.toLowerCase())

export const formatEpisodeDate = (iso: string) =>
  new Date(`${iso}T12:00:00`).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  })
